module.exports = "/_next/static/images/329d1530859b7e1e17e06678344ced41-young-people-walking@3x.jpg";